const getDictForFunction = (dict, functionName) => dict == null ? void 0 : dict.find((entry) => entry.name === functionName);
const jsonifyText = (text) => {
  try {
    JSON.parse(text);
    return text;
  } catch {
    try {
      const rawMessageToJson = `{"${text.trim().replace(/^\s*\n/gm, "").replace(/"/g, '\\"').split("\n").map(
        (line) => line.trim().split(":").map((keyValue) => keyValue.trim())
      ).filter((keyValue) => keyValue[0] && keyValue[1]).map((keyValue) => `${keyValue[0].replace(/\\"/g, "").trim()}":"${keyValue.slice(1).join(":").trim()}`).join('","')}"}`;
      JSON.parse(rawMessageToJson);
      return rawMessageToJson;
    } catch {
      return JSON.stringify({ message: text });
    }
  }
};
const hasRuleBuilderErrors = (rule) => {
  var _a, _b, _c, _d, _e, _f;
  if (((_b = (_a = rule == null ? void 0 : rule.rule_builder) == null ? void 0 : _a.errors) == null ? void 0 : _b.length) > 0) return true;
  if ((_d = (_c = rule == null ? void 0 : rule.rule_builder) == null ? void 0 : _c.actions) == null ? void 0 : _d.some((action) => {
    var _a2;
    return ((_a2 = action.errors) == null ? void 0 : _a2.length) > 0;
  })) {
    return true;
  }
  if ((_f = (_e = rule == null ? void 0 : rule.rule_builder) == null ? void 0 : _e.conditions) == null ? void 0 : _f.some((condition) => {
    var _a2;
    return ((_a2 = condition.errors) == null ? void 0 : _a2.length) > 0;
  })) {
    return true;
  }
  return false;
};
export { getDictForFunction, jsonifyText, hasRuleBuilderErrors };
